import styled from "styled-components";

export const RolesAndPermissionsStyles = styled.div`
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes roleDelete {
    to {
      opacity: 0;
      transform: translateX(-30px);
    }
  }

  .headerCard {
    margin-bottom: ${({ theme }) => theme.spacing[16]};
  }

  .header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .addRole {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .searchBar {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};
    width: 100%;
  }

  .searchContainer {
    width: 280px;
    height: 42px;
    border-radius: ${({ theme }) => theme.radius[12]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    overflow: hidden;
    color: ${({ theme }) => theme.colors.semantic.icon.weak};
    transition: border-color 0.2s ease, color 0.2s ease;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
      color: ${({ theme }) => theme.colors.semantic.icon.strong};
    }

    .searchInput {
      border: none;
      border-radius: 0;
    }
  }

  .rolesList {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[16]};

    .roleCard {
      opacity: 0;
      animation: fadeIn 0.35s ease both;
      ${Array.from({ length: 12 }, (_, i) => `&:nth-child(${i + 1}) { animation-delay: ${0.12 + i * 0.05}s; }`).join("\n      ")}

      &.deleting {
        animation: roleDelete 0.3s ease forwards !important;
        pointer-events: none;
      }
    }
  }

  .roleCardHeader {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .roleName {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .actions {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .permissionsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .permissionTag {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: ${({ theme }) => theme.radius[24]};
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.1px;
  }

  .roleDescription {
    margin-top: ${({ theme }) => theme.spacing[12]};
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }
`;
